<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
      d="M13.0704 0H4.6738C3.18981 0 1.98242 1.20739 1.98242 2.69138V17.3086C1.98242 18.7926 3.18981 20 4.6738 20H15.3273C16.811 20 18.0184 18.7929 18.0184 17.3086V5.53029L13.0704 0ZM13.4624 2.56584L15.7228 5.0922H13.4624V2.56584ZM15.3268 18.5815H4.6738C3.97188 18.5815 3.40093 18.0105 3.40093 17.3086V2.69138C3.40093 1.98946 3.97188 1.41851 4.6738 1.41851H12.0441V6.51047H16.5999V17.3086C16.5997 18.0105 16.0287 18.5815 15.3268 18.5815Z"/>
  <path d="M15.0773 14.3385H4.92383V15.757H15.0773V14.3385Z"/>
  <path d="M15.0773 11.2561H4.92383V12.6746H15.0773V11.2561Z"/>
  <path d="M15.0773 8.17414H4.92383V9.59265H15.0773V8.17414Z"/>
</svg>
</template>
